import React, { memo, forwardRef } from "react";
const SvgRationalnumbers = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.62 15.78c0-.72-.113-1.387-.34-2a4.457 4.457 0 00-.98-1.58 4.45 4.45 0 00-1.5-1.04c-.587-.253-1.24-.38-1.96-.38-.68 0-1.32.127-1.92.38-.587.253-1.093.6-1.52 1.04-.427.44-.767.967-1.02 1.58-.24.613-.36 1.28-.36 2 0 .76.113 1.453.34 2.08.24.613.567 1.14.98 1.58.427.44.933.787 1.52 1.04.587.24 1.233.36 1.94.36.693 0 1.333-.12 1.92-.36.6-.253 1.113-.6 1.54-1.04.427-.44.76-.967 1-1.58.24-.627.36-1.32.36-2.08zm2.74 0a6.624 6.624 0 01-.8 3.22 5.448 5.448 0 01-.8 1.14 5.8 5.8 0 01-.92.82V21h2.54c.24 0 .433.04.58.12.147.067.26.153.34.26a.77.77 0 01.18.34c.027.12.04.22.04.3 0 .08-.013.18-.04.3a.769.769 0 01-.18.34c-.08.107-.193.2-.34.28-.147.067-.34.1-.58.1H15.8c-1.133 0-2.167-.16-3.1-.48a6.98 6.98 0 01-2.38-1.42 6.456 6.456 0 01-1.52-2.28c-.36-.907-.54-1.933-.54-3.08 0-1.08.187-2.06.56-2.94a6.86 6.86 0 011.6-2.3 7.124 7.124 0 012.4-1.48 8.32 8.32 0 013.02-.54c1.08 0 2.08.18 3 .54a6.91 6.91 0 012.38 1.48 6.624 6.624 0 011.58 2.3c.373.88.56 1.86.56 2.94z"
      />
    </svg>
  );
});
SvgRationalnumbers.displayName = "SvgRationalnumbers";
const MemoForwardRef = memo(SvgRationalnumbers);
export default MemoForwardRef;
